export const getSeoBrandName = (isInternational) =>
    isInternational ? 'Garage Clothing' : 'Garage Clothing UK'

export const getHomepageSeoRoutes = (locales = []) => [
    '/',
    ...new Set(
        locales
            .map((locale) => locale?.alias)
            .filter(Boolean)
            .map((alias) => `/${alias}`)
    )
]
